"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lightPalette = void 0;
var _styles = require("@mui/material/styles");
var theme = (0, _styles.createTheme)({
  // Theme customization goes here as usual, including tonalOffset and/or
  // contrastThreshold as the augmentColor() function relies on these
});
var lightPalette = exports.lightPalette = {
  mode: 'light',
  background: {
    "default": '#F5F5F5',
    paper: '#FFFFFF'
  },
  dividerHex: '#e0e0e0',
  text: {
    primary: 'rgba(0,0,0,0.87)',
    secondary: 'rgba(0,0,0,0.6)',
    disabled: 'rgba(0,0,0,0.38)',
    icon: 'rgba(0,0,0,0.5)'
  },
  primary: theme.palette.augmentColor({
    color: {
      main: '#4f78a0' //4f779f from logo
    },
    name: 'primary'
  }),
  secondary: theme.palette.augmentColor({
    color: {
      main: '#4085F3'
    },
    name: 'secondary'
  }),
  info: theme.palette.augmentColor({
    color: {
      main: '#44c8f5' //'#0288D1',//
    },
    name: 'info'
  }),
  warning: theme.palette.augmentColor({
    color: {
      main: '#ED6C02'
    },
    name: 'warning'
  }),
  success: theme.palette.augmentColor({
    color: {
      main: '#288500'
    },
    name: 'success'
  }),
  pending: theme.palette.augmentColor({
    color: {
      main: '#F1B601'
    },
    name: 'pending'
  }),
  payment: theme.palette.augmentColor({
    color: {
      main: '#B85CB6'
    },
    name: 'payment'
  }),
  inactive: theme.palette.augmentColor({
    color: {
      main: '#8F8F8F'
    },
    name: 'inactive'
  }),
  draft: theme.palette.augmentColor({
    color: {
      main: '#666666'
    },
    name: 'inactive'
  }),
  error: theme.palette.augmentColor({
    color: {
      main: 'rgb(211, 47, 47)'
    },
    name: 'error'
  })
};